<template>
  <div class="admin-layout">
    <!-- 左侧菜单 -->
    <div class="sidebar">
      <AdminSidebar />
    </div>

    <!-- 右侧主体 -->
    <div class="main-container">
      <div class="header">
        <AdminHeader />
      </div>
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import AdminSidebar from '@/components/layout/AdminSidebar.vue'
import AdminHeader from '@/components/layout/AdminHeader.vue'

export default {
  name: 'AdminLayout',
  components: {
    AdminSidebar,
    AdminHeader
  }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  width: 100%;
  height: 100vh;
  background: #f5f7fa;
}

.sidebar {
  width: 180px; /* 原来如果更宽，这里改窄 */
  min-width: 180px;
  max-width: 180px;
  background: #304156;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}
</style>